import { render, staticRenderFns } from "./upay.vue?vue&type=template&id=2f44384c&scoped=true"
import script from "./upay.vue?vue&type=script&lang=js"
export * from "./upay.vue?vue&type=script&lang=js"
import style0 from "./upay.vue?vue&type=style&index=0&id=2f44384c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f44384c",
  null
  
)

export default component.exports